<template>
  <div>
    <div v-if="hasPermissionToView">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="route.meta.title"
            :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
          />
        </div>
        <div class="flex-center">
          <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
            <v-icon left>mdi-file-excel</v-icon> Xuất Excel
          </v-btn>
          <v-btn v-if="hasPermissionToCreate" class="ml-6" depressed dark color="#0D47A1" @click="openDialog">
            <v-icon left>add</v-icon>Thêm nhóm
          </v-btn>
        </div>
      </div>
      <v-card outlined class="pa-9 pr-3 mx-4 mb-6 elevation-0">
        <group-filter ref="groupFilter" />
      </v-card>
      <v-card outlined class="mx-4 elevation-0">
        <group-table ref="salaryGroupTable" />
      </v-card>
      <group-dialog @addGroupSuccess="addGroupSuccess" action="create" ref="groupDialog" />
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import GroupFilter from './group-list/GroupFilter.vue'
import GroupTable from './group-list/GroupTable.vue'
import GroupDialog from './group-list/GroupDialog.vue'
import { textHelpers } from '@/helpers/TextHelper.js'
import { mapActions, mapState } from 'vuex'
import Page403 from '@/views/Page403.vue'
import utils from '@/plugins/utils'
export default {
  components: {
    Breadcrumbs,
    GroupFilter,
    GroupTable,
    GroupDialog,
    Page403
  },
  computed: {
    ...mapState('salaryGroup', ['salaryGroups', 'salarySearchParams']),
    route() {
      return this.$route
    },
    hasPermissionToView() {
      // return $auth.policies['view-tuition-fee-group-list']
      return true
    },
    hasPermissionToCreate() {
      // return $auth.policies['add-new-tuition-fee-group']
      return true
    }
  },
  methods: {
    ...mapActions('salaryGroup', ['fetchGroups']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.salaryGroupTable.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const list = await this.fetchGroups({
          ...this.salarySearchParams,
          _sort: 'createdAt:desc',
          _limit: -1
        })
        const salaryGroups = JSON.parse(JSON.stringify(list))
        const data = salaryGroups.map(item => {
          item.category = textHelpers.getCategory(item.category)
          return item
        })
        utils.exportExcel(data, excelHeader, `Danh sách ${this.route.meta.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    openDialog() {
      this.$refs.groupDialog.openDialog()
    },
    addGroupSuccess() {
      this.$refs.groupFilter.addGroupSuccess()
    }
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
